export const ExperimentsConsts = {
  WixFormsMigration: 'specs.bookings.WixFormsMigration',
  UseMoment: 'specs.bookings.MyBookingsUseMoment',
  RemoveSkipPreferencesModalParam:
    'specs.bookings.removeSkipPreferencesModalParam',
};
